export enum Pages {
    LANDINGPAGE = 'landingpage',
    TEILEIDENTIFIKATION = 'teileidentifikation',
    LAGERERGAENZUNG = 'lagerergaenzung',
    KATALOGSCHNITTSTELLE = 'katalogschnittstelle',
    NETTOPREISSCHNITTSTELLE = 'nettopreisschnittstelle',
    VERFUEGBARKEITSSCHNITTSTELLE = 'verfuegbarkeitsschnittstelle',
    BESTELLSCHNITTSTELLE = 'bestellschnittstelle',
    KUNDENZITATE = 'kundenzitate',
    KONTAKT = 'kontakt',
}

export type InfoBox = {
    icon: string,
    headline: string;
    list: AnyJsx[]
}

export type ContentImages = {
    main: string;
}

export type PageTypeLandingpage = {
    headline: string;
    headlineWidth: number;
    buttonContact: string;
    buttonTestimonials: string;
    tooltips: ClickableText;
    background: string;
    images: {
        leftUpper: string;
        leftLower: string;
        big: string;
    }
}

export type PageTypeInfoPage = {
    headline: string;
    intro?: string;
    text: AnyJsx;
    infoBoxes?: InfoBox[];
    images: ContentImages;
    icon: AnyJsx;
};

export type PageTypeProcessPage = {
    headline: string;
    headlineWidth: number;
    infoBox: {
        headline: string;
        bullets: AnyJsx[];
    };
    steps: ProcessPageStepLanguage[];
};

export type AnyJsx = any; // TODO: Any value that may be used in JSX

export type ProcessPageStepLanguage = {
    headline: string;
    content: AnyJsx;
    imageUrl: string;
};

export type Testimonial = {
    name: string;
    job: string;
    quotes: string[];
    imageUrl?: string | undefined;
};

export type InfoLayerType = {
    text: AnyJsx;
    button: string;
};

export type Language = {
    id: string;
    languageName: string;
    flagUrl: string;
    headerHeading: string;
    landingpage: PageTypeLandingpage;
    backToLandingPageLabel: string;
    infolayer: InfoLayerType;
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: PageTypeProcessPage;
        [Pages.LAGERERGAENZUNG]: PageTypeProcessPage;
    };
    infoPages: {
        [Pages.BESTELLSCHNITTSTELLE]: PageTypeInfoPage;
        [Pages.KATALOGSCHNITTSTELLE]: PageTypeInfoPage;
        [Pages.NETTOPREISSCHNITTSTELLE]: PageTypeInfoPage;
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: PageTypeInfoPage;
    };
    testimonialsPage: {
        headline: string;
        headlineWidth: number;
        testimonials: Testimonial[];
        footer: {
            headline: string;
            companies: string[];
        };
    };
    contactPage: {
        headline: string;
        headlineWidth: number;
        name?: string;
        imageUrl: string;
        texts: AnyJsx[];
        job?: string;
        stepsHeadline: string;
        steps: AnyJsx[];
        text: AnyJsx;
        email: string;
    };
};

export interface ClickableText {
    availability: string; // #AB6-Beschaffungsprozess-eProcurement-Click-Explainer#
    catalogue: string; // #AB2-Beschaffungsprozess-eProcurement-Click-Explainer#
    identification: string; // #AB1-Beschaffungsprozess-eProcurement-Click-Explainer#
    order: string; // #AB3-Beschaffungsprozess-eProcurement-Click-Explainer#
    price: string; // #AB5-Beschaffungsprozess-eProcurement-Click-Explainer#
    storage: string; // #AB4-Beschaffungsprozess-eProcurement-Click-Explainer#
}

export interface DimensionProps {
    width: number;
}
